import { toast } from "react-toastify";

import { useEffect, useRef, useState } from "react";

import Loader from "../../../../components/Loader";
import { API_BASE_URL } from "../../../../config";
import { getAdminAuthToken } from "../../../../auth/auth";

import closeIcon from "../../../../assets/close-dialog-x.svg";

export default function AdminsList({ refreshTrigger }) {
  const dialogRef = useRef();
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const token = getAdminAuthToken();

  useEffect(() => {
    const adminList = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/admin/admins`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();

        if (result.success === false) {
          return;
        }

        setAdmins(result.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching admins:", error);
      }
    };

    if (token) {
      adminList();
    }
  }, [token, refreshTrigger]);

  const handleDeleteAdmins = async () => {
    dialogRef.current.close();
    setIsDeleting(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/admins/${selectedAdmin}`,
        {
          method: "delete",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (!result.success) {
        toast.error(result.message);
        setIsDeleting(false);
        return;
      }

      setAdmins((prev) => prev.filter((admin) => admin.id !== selectedAdmin));
      setIsDeleting(false);
      toast.success("Admin removed successfully!");
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  const handleOpenDialog = (id) => {
    dialogRef.current.showModal();
    setSelectedAdmin(id);
  };

  const handleCloseDialog = () => {
    dialogRef.current.close();
  };

  return (
    <>
      <div className="admins-list-parent">
        <h3>Admins</h3>
        <div className="admin-list-wrapper">
          {isLoading ? (
            <Loader />
          ) : (
            admins?.map((curr) => (
              <div
                className={`admin-list-single ${
                  isDeleting ? "blink-disabled" : ""
                }`}
                key={curr.id}
              >
                <div className="admin-list-single__left">
                  <h3>{curr.name}</h3>
                  <p>{curr.email}</p>
                </div>
                <div className="admin-list-single__right">
                  <button onClick={() => handleOpenDialog(curr.id)}>
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
          <dialog ref={dialogRef} className="dialog-all">
            <button onClick={handleCloseDialog}>
              <img src={closeIcon} />
            </button>
            <h3>Are you sure you want to remove admin</h3>
            <p>
              This action will parentally delete admin access to this user
              without possibility to restore it
            </p>
            <div className="remove-admin-btn-group">
              <button onClick={handleCloseDialog}>Cancel</button>
              <button onClick={handleDeleteAdmins}>Remove</button>
            </div>
          </dialog>
        </div>
      </div>
    </>
  );
}
